import { UPDATE_NEWS, UPDATE_CREATIVES, UPDATE_MOTD, UPDATE_HASH } from './constants'

export function updateNews(hash) {
    return {
        type: UPDATE_NEWS,
        payload: hash,
    }
}

export function updateCreatives(timestamp) {
    return {
        type: UPDATE_CREATIVES,
        payload: timestamp,
    }
}

export function updateMotd(timestamp) {
    return {
        type: UPDATE_MOTD,
        payload: timestamp,
    }
}

export function updateHash(hash) {
    return {
        type: UPDATE_HASH,
        payload: hash,
    }
}



// WEBPACK FOOTER //
// ./src/features/Sync/data/hashes/actions.js